import { ForbiddenIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { useConfirmationDialogContext } from '@va/shared/util-confirmation';
import { getUserRole } from '@va/standalone/shared/selectors';
import { UserRole } from '@va/types/website';
import { BulkOperations, SelectActionDropdownOption } from '@va/ui/design-system';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import DeleteSegmentsConfirmationDialog from './DeleteSegmentsConfirmationDialog';
import { useVisitorSegmentsContext } from './VisitorSegmentsContext';
import { segmentsSelectOptionsEnum } from './types';

export const SegmentsBulkOperations = () => {
  const translate = useTranslate();
  const userRole = useSelector(getUserRole);
  const hasEditPermission = userRole !== UserRole.WATCHER;

  const { confirm } = useConfirmationDialogContext();

  const {
    selectAllSegments,
    setSelectedBulkOption,
    selectedBulkOption,
    selectedSegmentsIds,
    deleteSegments,
    totalEditCount,
    clearAllSelectedSegments,
  } = useVisitorSegmentsContext();

  const selectOptions: SelectActionDropdownOption[] = useMemo(
    () => [
      {
        onClick: () => {
          selectAllSegments();
          setSelectedBulkOption(segmentsSelectOptionsEnum.all);
        },
        text: translate('behaviourStatus.All', { count: totalEditCount }),
      },
    ],
    [translate, totalEditCount, selectAllSegments, setSelectedBulkOption],
  );

  const actionsOptions: SelectActionDropdownOption[] = useMemo(
    () => [
      {
        onClick: () => {
          confirm(() => {
            deleteSegments(selectedSegmentsIds);
          }, DeleteSegmentsConfirmationDialog);
        },
        text: translate('segments.actions.deleteMany'),
        icon: () => <ForbiddenIcon />,
        disabled: !hasEditPermission,
        tooltip: !hasEditPermission ? translate('tooltips.contributorRole') : undefined,
      },
    ],
    [confirm, deleteSegments, hasEditPermission, selectedSegmentsIds, translate],
  );

  return (
    <BulkOperations
      allSelected={selectedBulkOption === segmentsSelectOptionsEnum.all}
      selectedItemsCount={selectedSegmentsIds.length}
      selectOptions={selectOptions}
      actionsOptions={actionsOptions}
      clearSelectedItems={clearAllSelectedSegments}
      selectedOption={selectedBulkOption}
    />
  );
};
